const schema = () => ({
  type: "object",
  required: ["register_date", "tellphone"],
  properties: {
    title: {
      type: "string",
      title: "عنوان",
    },
    national_identifier: {
      type: "string",
      title: "شناسه ملی",
      pattern: "^[0-9]*$",
      minLength: 5,
      maxLength: 16,
    },
    location: {
      type: "object",
      title: "location",
      properties: {
        lat: {
          type: "string",
        },
        lng: {
          type: "string",
        },
        state: {
          type: "string",
        },
        city: {
          type: "string",
        },
      },
    },
    registered_number: {
      type: "string",
      title: "شماره ثبت",
      pattern: "^[0-9]*$",
    },
    register_date: {
      type: "string",
      title: "تاریخ ثبت",
    },
    tellphone: {
      type: "string",
      title: "تلفن",
      pattern: "^09[0-9]{9}$",
    },
    postal_code: {
      type: "string",
      title: "کدپستی",
      pattern: "[0-9]{10}$",
    },
    address: {
      type: "string",
      title: "آدرس",
    },
  },
});

export default schema;
